import React, {useState} from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {gameUiTexts} from 'data/ui-texts';
import {roundsData} from 'data/rounds-data';
import {getText, renderMarkdown} from 'helpers/text-helper';
import cglLogo from 'assets/images/gamelab-logo.svg';
import Logo from 'components/ui/logo/logo';
import Button from 'components/ui/button/button';
import './store-front.scss';
import PopupVideo from 'components/ui/popup-video/popup-video';

const StoreFront = ({
	nextLanguage,
	languageId,
	isEndingRound,
	animateEnterShop,
	newRoundNumber,
	handleStartGame,
	setCookiePopupType}) => {

	/* Video popup */
	const [showVideoPopup, setShowVideoPopup] = useState(false);

	return (
		<div className={'StoreFront' + (animateEnterShop ? ' enterShop' : '')}>
			<div className='StoreFront-store' />
			<div className='StoreFront-characters' />
			{!isEndingRound &&
				<div className='StoreFront-logos'>
					<div className='StoreFront-logoGameLab' onClick={() => {window.open('https://cphgamelab.dk/', '_blank', 'noopener,noreferrer');}}>
						<img src={cglLogo} alt="Læringsspil udviklet af Copenhagen Game Lab" />
					</div>
					<div className='StoreFront-fundLogo'/>
				</div>
			}

			{!isEndingRound && <div className="StoreFront-logo">
				<Logo />
			</div>}
			{!isEndingRound && <div className={'StoreFront-subtitle ' + languageId}>
				<span>{getText(gameUiTexts.subtitle, languageId)}</span>
			</div>}
			{!isEndingRound && <div className="StoreFront-startBtn">
				<Button
					text={getText(gameUiTexts.start, languageId)}
					classes={['blue', 'start']}
					onClick={() => {handleStartGame();}}
				/>
			</div>}
			{!isEndingRound && <div className="StoreFront-manualBtn">
				<Button
					text={getText(gameUiTexts.manual, languageId)}
					type="download"
					classes={['blue', 'start']}
					href="/files/manual.pdf"
				/>
			</div>}
			{!isEndingRound && <div className="StoreFront-videoBtn">
				<Button
					text={getText(gameUiTexts.viewVideo, languageId)}
					classes={['blue', 'video']}
					onClick={() => {setShowVideoPopup(true);}}
				/>
			</div>}
			{!isEndingRound && <div
				className={'StoreFront-switchLanguage ' + languageId}
				onClick={() => { nextLanguage(); }}
			/>}
			{!isEndingRound && <div
				className="StoreFront-toggleCookiePopup"
				onClick={() => {setCookiePopupType('default');}}
			/>}

			{isEndingRound && <div className="StoreFront-roundAnimation">
				<div className="StoreFront-rounds">
					<div className="StoreFront-line" />
					{roundsData.map((round) => {
						const roundStatus = (round.roundNumber < newRoundNumber
							? 'completed'
							: (round.roundNumber === newRoundNumber ? 'new' : null)
						);
						return (
							<div
								key={round.roundNumber}
								className={'StoreFront-round' + (roundStatus ? ' ' + roundStatus : '')}
							>
								<span>{getText(round.title, languageId)}</span>
							</div>
						);
					})}
				</div>
				<div className="StoreFront-text">
					{renderMarkdown(getText(gameUiTexts.betweenRoundsText, languageId))}
				</div>
				<div className="StoreFront-animation" />
				<div className="StoreFront-timer">
					<div
						className={'StoreFront-track'}
						style={{'--duration': appConfig.newRoundAnimationDurationSec + 's'}}
					/>
				</div>
			</div>}

			{/* Video popup */}
			{showVideoPopup && <PopupVideo setShowVideoPopup={setShowVideoPopup} />}

		</div>
	);
};

StoreFront.propTypes = {
	nextLanguage: PropTypes.func.isRequired,
	languageId: PropTypes.string.isRequired,
	isEndingRound: PropTypes.bool.isRequired,
	animateEnterShop: PropTypes.bool.isRequired,
	newRoundNumber: PropTypes.number,
	handleStartGame: PropTypes.func.isRequired,
	setCookiePopupType: PropTypes.func.isRequired,
};

export default StoreFront;